export const uid2date = (uid: string) => {
  return new Date(parseInt(uid.substring(0, 13)))
}
